const expandEl = document.querySelector<HTMLElement>(".questionnaire-story-expand");
const collapseEl = document.querySelector<HTMLElement>(".questionnaire-story-collapse");

if (expandEl && collapseEl) {
    const parent = expandEl.closest<HTMLElement>('.questionnaire-story-content')!;
    const panel = parent.querySelector<HTMLElement>('.questionnaire-story-details')!;

    // scroll to end
    panel.scrollTo(0, panel.scrollHeight);
    // expand
    expandEl.addEventListener('click', (e) => {
        e.preventDefault();
        expandSection(panel, () => {
            parent.classList.add('expand');
        });
    });
    // collapse
    collapseEl.addEventListener('click', (e) => {
        e.preventDefault();
        collapseSection(panel, () => {
            parent.classList.remove('expand');
        });
    });



    // story scroll effect
    panel.addEventListener('scroll', () => {
        if (panel.scrollTop > 4) {
            parent.classList.add('scrolled');
        } else {
            parent.classList.remove('scrolled');
        }
    });
}


// This is the important part!

export function collapseSection(element: HTMLElement, callback: () => void) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // temporarily disable all css transitions
    var elementTransition = element.style.transition;
    element.style.transition = '';

    // on the next frame (as soon as the previous style change has taken effect),
    // explicitly set the element's height to its current pixel height, so we 
    // aren't transitioning out of 'auto'
    requestAnimationFrame(function () {
        element.style.height = sectionHeight + 'px';
        element.style.transition = elementTransition;

        // on the next frame (as soon as the previous style change has taken effect),
        // have the element transition to height: 0
        requestAnimationFrame(function () {
            element.style.height = 0 + 'px';
        });
    });

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', function _myHandler(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', _myHandler);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = '';
        callback();
    });
    // mark the section as "currently collapsed"
    element.setAttribute('data-collapsed', 'true');
}

export function expandSection(element: HTMLElement, callback: () => void) {
    // get the height of the element's inner content, regardless of its actual size
    var sectionHeight = element.scrollHeight;

    // have the element transition to the height of its inner content
    element.style.height = sectionHeight + 'px';

    // when the next css transition finishes (which should be the one we just triggered)
    element.addEventListener('transitionend', function _myHandler(e) {
        // remove this event listener so it only gets triggered once
        element.removeEventListener('transitionend', _myHandler);

        // remove "height" from the element's inline styles, so it can return to its initial value
        element.style.height = '';
        callback();
    });

    // mark the section as "currently not collapsed"
    element.setAttribute('data-collapsed', 'false');
}

// care for panel
const ckMyself = document.querySelector<HTMLInputElement>("#ckMyself");
const ckSomeoneElse = document.querySelector<HTMLInputElement>("#ckSomeoneElse");
const careForPanel = document.querySelector("#careForPanel");

if (ckMyself && ckSomeoneElse && careForPanel) {
    let disabled = (ckMyself.checked && !ckSomeoneElse.checked) || (!ckMyself.checked && !ckSomeoneElse.checked);
    if (careForPanel.querySelector("input[type='radio']:checked:not(#ckSomeoneElse):not(#ckMyself)")) {
        disabled = false;
        ckSomeoneElse.checked = true;
    }
    careForPanel.querySelectorAll("input[type='radio']:not(#ckSomeoneElse):not(#ckMyself)").forEach((item: HTMLInputElement) => {
        item.disabled = disabled;
    });

    ckMyself.addEventListener('change', (e) => {
        if (ckMyself.checked) {
            ckSomeoneElse.checked = false;
        }
        updateCheckboxes();
    });
    ckSomeoneElse.addEventListener('change', (e) => {
        if (ckSomeoneElse.checked) {
            ckMyself.checked = false;
        }
        updateCheckboxes();
    });
}
function updateCheckboxes() {
    careForPanel.querySelectorAll("input[type='radio']:not(#ckSomeoneElse):not(#ckMyself)").forEach((item: HTMLInputElement) => {
        item.disabled = ckMyself.checked;
    });
}
export default undefined;
